
import ByteView from '../index.js'

export default class Base16 {
  #encoding
  #alphabet
  #lookupTable = (function () {
    const alphabet = '0123456789abcdef'
    const table = new Array(256)
    for (let i = 0; i < 16; ++i) {
      const i16 = i * 16
      for (let j = 0; j < 16; ++j) {
        table[i16 + j] = alphabet[i] + alphabet[j]
      }
    }
    return table
  })()

  constructor () {
    this.#encoding = 'hex'
    this.#alphabet = '0123456789abcdef'
  }

  get [Symbol.toStringTag] () {
    return 'Base16'
  }

  get encoding () {
    return this.#encoding
  }

  decode (string) {
    const { length } = string
    let index = -1
    let bvi = -1
    const byteView = new ByteView((length / 2) | 0)

    while (++index < length) {
      const char = string[index] + string[++index]
      byteView[++bvi] = Number(`0x${char}`)
    }

    return byteView
  }

  encode (buffer, deliminator = '') {
    const output = []

    let index = -1
    const { length } = buffer
    while (++index < length) {
      output.push(this.#lookupTable[buffer[index]])
    }

    return output.join(deliminator)
  }
}
